import React from "react";
import { Link } from "react-router-dom";
import { FaRegUserCircle } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaBed } from "react-icons/fa";
import { FaBookReader } from "react-icons/fa";
import { FaUserMd } from "react-icons/fa";
import { FaCogs } from "react-icons/fa";
import { FaPlusCircle } from "react-icons/fa";

function RelaxationSidebar() {
  const userInfo = JSON.parse(localStorage.getItem("userLoggedIn"));
  return (
    <div>
      <aside className="bg-[#F5F5F5] hidden md:block top-0 left-0 h-screen transition-transform shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md pl-4">
        <div className="h-full px-4 py-5 overflow-y-auto">
          <div className="w-full flex space-x-3 mb-12">
            <div className="text-5xl text-[#314C1C]">
              <FaRegUserCircle />
            </div>
            <div>
              <p className="text-lg font-semibold text-[#314C1C]">
                Welcome Back
              </p>
              <p className="text-lg text-[#314C1C] font-semibold">
                {`${userInfo.firstName}`}
              </p>
            </div>
          </div>
          <ul className="space-y-4 mb-9  text-[#314C1C] font-semibold">
            <li>
              <Link to="/" className="flex gap-2">
                <FaHome className="text-xl" />
                Home
              </Link>
            </li>
            <li>
              <Link to="/community" className="flex gap-2">
                <FaUsers className="text-xl" />
                <p>Community</p>
              </Link>
            </li>
            <li>
              <Link to="/relaxation1" className="flex gap-2">
                <FaBed className="text-xl" />
                Relaxation
              </Link>
            </li>
            <li>
              <Link to="/mainresources" className="flex gap-2">
                <FaBookReader className="text-xl" />
                Resources
              </Link>
            </li>
            <li>
              <Link to="/therapy" className="flex gap-2">
                <FaUserMd className="text-xl" />
                Therapy
              </Link>
            </li>
            <li>
              <Link to="/settingsprofile" className="flex gap-2">
                <FaCogs className="text-xl" />
                Settings
              </Link>
            </li>
          </ul>
          <Link to="/moodtrack">
            <button
              type="button"
              className="text-[#314C1C] border border-[#314C1C] p-4 px-4 rounded-md flex gap-2"
            >
              <div>
                <FaPlusCircle className="text-xl" />
              </div>
              <p className="text-[#314C1C] font-semibold">Mood Tracker</p>
            </button>
          </Link>
        </div>
      </aside>
    </div>
  );
}

export default RelaxationSidebar;
